import { CartProductItem } from '@westwing/ui-kit/ContentFlyout/CartFlyout/types';

export interface CartInfoResponse {
    code: {
        cart: string;
        // eslint-disable-next-line camelcase
        cart_changed: boolean;
        expired: boolean;
        products: CartProductItem[];
        // eslint-disable-next-line camelcase
        seconds_left: number;
        total: number;
        totalPrice: string;
    };
    redirect: string;
    success: boolean;
}

export default async function request(requestCartInfoUrl: string): Promise<CartInfoResponse> {
    const response = await fetch(requestCartInfoUrl, {
        method: 'GET',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'content-type': 'text/html; charset=utf-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
    });

    return response.json();
}
